"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorLogger = void 0;
var tslib_1 = require("tslib");
var user_feedback_common_1 = require("@wix/user-feedback-common");
var bi_error_logger_1 = require("../../bi/bi-error-logger");
exports.createErrorLogger = function () {
    var configurator = new user_feedback_common_1.ErrorLoggerConfigurator();
    return {
        withDefaultBi: function (defaultParams) {
            var biErrorHandler = function (error, params) {
                // tslint:disable-next-line no-floating-promises
                bi_error_logger_1.biErrorLogger.log(tslib_1.__assign(tslib_1.__assign({}, defaultParams), user_feedback_common_1.getErrorBiParams(error, params)));
            };
            return configurator.addErrorHandler(biErrorHandler).createLogger();
        },
    };
};
//# sourceMappingURL=error-logger.js.map